import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    
    &>div{
        display:grid;
        margin-bottom:0.3rem;
        &>:last-child{
            text-align:right;
            .val{
                justify-content:flex-end;
            }
        }
        .firstLbl{
            color:var(--light-gray);
            margin-bottom:0.5rem;
        }
        
        .val{
            margin-top:0.3rem;
            font-weight:500;
            font-weight:bold;
            color:var(--dark-gray);
            display:flex;
            align-items:center;
            gap:0.4rem;
            &>span:not(.bonusBadge):not(.perMileBadge){
                color: var(--light-gray);
            }
        }
        .bonusBadge, .perMileBadge{
            font-size: 0.85rem;
            font-weight: bold;
            padding: 0.2rem 0.5rem;
            border-radius: 6px;
            line-height: 1.2;
        }
        .bonusBadge{
            color: var(--main-color);
            background: rgba(var(--successGreenRGB), 0.15);
        }
        .perMileBadge{
            color: rgb(var(--inProgressPurpleRGB));
            background: rgba(var(--inProgressPurpleRGB), 0.15);
        }
        .paid{
            color:var(--main-color);
        }
    }
`
const NoFeesOrCharges = styled.div`
    color:red;
    text-align:center;
    font-weight:bold;
    font-size:1.5em;
    color:var(--extra-light-gray);
    padding: 1rem 0rem;
`

export const RecurringPayments = ({data})=> {
    return <Container $smallerfont={false}>
        {data && data.length > 0 ? 
        <>
        {
            data.map((installment, index ) => {
                let withLabel = true;
                if (index > 0)withLabel = false;
                return <div  key={index} style={{gridTemplateColumns:"55% 1fr 1fr"}}>
                    <div>
                        {withLabel?<div className='firstLbl'>Title</div>:null}
                        <div className={`val`}>
                            {installment.title}
                            {installment.type === "bonus" || installment.cat === "bns" ? <span className="bonusBadge">Bonus</span> : null}
                            {installment.perMile ? <span className="perMileBadge">Per Mile</span> : null}
                        </div>
                    </div>
                    <div>
                        {withLabel?<div className='firstLbl'>Rate</div>:null}
                        <div className={`val`}>
                            {installment.perMile
                                ? `$${Number(installment.weeklyRate || 0).toFixed(2)}/mi`
                                : `$${installment.weeklyRate}`}
                        </div>
                        
                    </div>
                    <div>
                        {withLabel?<div className='firstLbl'>Daily Calculation</div>:null}
                        <div className={`val`}>
                            {!installment.perMile && installment.allowDailyCalculation ? "Yes" : "No"}
                        </div>
                    </div>
                </div>
            })
        }
        </>
        :
        <NoFeesOrCharges> No Recurring Payments Were Found</NoFeesOrCharges>
        }
        
    </Container>

}

